export enum NoCoverType {
  No = 'X',
  Yes = '✔',
  OnCrit = 'OnCrit',
}

export default NoCoverType;